import Highcharts from 'highcharts';
import { filterByCategory } from './data.js';
import { gradientHex } from '../helpers/colors.js';

export function getMandatyFinanse() {
    const categories = [
        'Mandaty: liczba wystawionych',
        'Etaty: liczba strażników',
        'Budżet',
        'Mandaty: wartość',
        'Mandaty: liczba wystawionych dot. PRD',
        'Mandaty: wartość wystawionych dot. PRD'
    ];
    const data = filterByCategory(categories);

    // Filtruj miasta z kompletnymi danymi dla podstawowych statystyk
    const validData = data.filter(sm =>
        sm['Mandaty: liczba wystawionych'] !== null &&
        sm['Etaty: liczba strażników'] !== null &&
        sm['Budżet'] !== null &&
        sm['Mandaty: wartość'] !== null &&
        typeof sm['Mandaty: liczba wystawionych'] === 'number' &&
        typeof sm['Etaty: liczba strażników'] === 'number' &&
        typeof sm['Budżet'] === 'number' &&
        typeof sm['Mandaty: wartość'] === 'number'
    );

    validData.forEach(sm => {
        // Mandaty na strażnika miesięcznie
        sm.finesPerGuardMonthly = Math.round((sm['Mandaty: liczba wystawionych'] / sm['Etaty: liczba strażników'] / 12) * 10) / 10;

        // Stopień samofinansowania (w %)
        sm.selfFinancingRate = Math.round((sm['Mandaty: wartość'] / sm['Budżet']) * 100 * 10) / 10;

        // Średnia wartość mandatu PRD
        if (sm['Mandaty: wartość wystawionych dot. PRD'] && sm['Mandaty: liczba wystawionych dot. PRD']) {
            sm.avgPrdFine = Math.round(sm['Mandaty: wartość wystawionych dot. PRD'] / sm['Mandaty: liczba wystawionych dot. PRD']);
        } else {
            sm.avgPrdFine = null;
        }
    });

    return validData.sort((a, b) => b.finesPerGuardMonthly - a.finesPerGuardMonthly);
}
export default function chartFinesStructure(id) {
    if (!document.getElementById(id)) return;

    const data = getMandatyFinanse();

    // Oblicz udział PRD (%) dla każdego miasta
    const chartData = data
        .filter(sm =>
            sm['Mandaty: liczba wystawionych dot. PRD'] != null &&
            sm['Mandaty: liczba wystawionych'] > 0
        )
        .map(sm => ({
            city: sm.city,
            prdPercent: Math.round(
                (sm['Mandaty: liczba wystawionych dot. PRD'] / sm['Mandaty: liczba wystawionych']) * 1000
            ) / 10
        }))
        .sort((a, b) => b.prdPercent - a.prdPercent);

    const categories = chartData.map(d => d.city);
    const prdPercents = chartData.map(d => d.prdPercent);
    const avg = 76;//Math.round(prdPercents.reduce((a, b) => a + b, 0) / prdPercents.length * 10) / 10;

    Highcharts.chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: 'Udział mandatów drogowych (PRD) w całkowitej liczbie mandatów'
        },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            title: { text: 'Udział mandatów PRD' },
            min: 0,
            max: 100,
            labels: { format: '{value}%' },
            gridLineWidth: 1,
            plotLines: [{
                value: avg,
                color: '#2c3e50',
                dashStyle: 'ShortDash',
                width: 1,
                label: {
                    text: `Średnia: ${avg}%`,
                    align: 'right',
                    verticalAlign: 'bottom',
                    style: { color: '#2c3e50', fontWeight: 'bold' }
                }
            }]
        },
        legend: { enabled: false },
        tooltip: {
            formatter: function () {
                return `<b>${this.x}</b><br/>Mandaty PRD: <b>${this.y}%</b>`;
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    format: '{y}%',
                    style: { fontSize: '11px', textOutline: 'none' }
                }
            },
            series: { borderWidth: 0 }
        },
        credits: { enabled: false },
        series: [{
            name: 'Udział PRD',
            color: '#FFFF00',
            data: prdPercents.map(d => ({
                y: d,
                color: d > avg ? '#cb3d20ff' : '#cb9520'
            }))
        }]
    });
}
